import { render, staticRenderFns } from "./UpdatesHistory.vue?vue&type=template&id=05462ff0"
import script from "./UpdatesHistory.vue?vue&type=script&lang=js"
export * from "./UpdatesHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports